import * as React from "react";
import Modal from "react-bootstrap/Modal";
import "./index.css";
export default function LoadingIndicator({ open, text = "" }) {
  const [openBackdrop, setOpenBackdrop] = React.useState(false);

  React.useEffect(() => {
    setOpenBackdrop(open);
  }, [open]);

  return (
    <Modal
      show={open}
      backdrop="static"
      keyboard={false}
      centered
      className="loading-indicator"
    >
      <Modal.Body className="p-0 text-center">
        <div className="spinner-grow text-theme"></div>
        {text && <p style={{ marginTop: 20, fontSize: "medium" }}>{text}</p>}
      </Modal.Body>
    </Modal>
  );
}
